import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/icon-union.svg")